module.exports = __webpack_public_path__ + "img/Big5Safari_EGM.2bb254e1.png";